import { useSelector } from 'react-redux';
import { ApplicationState } from 'src/store/ApplicationState.d';
import {  equals, join, pathOr } from 'ramda';
import { META_DATA } from 'src/services/constants';
import { buildLabel } from 'src/utilities/naming';
import { FALSE } from 'src/constants';
import SiteSettings from 'src/siteSetting';
import { TRUE } from 'src/features/core/Intents/intentConstants';
import { getActiveBorrowerAccount, getItemsByIdResources } from 'src/store/store.helpers';
import store from 'src/store';


export const getAccountFromStore = () => {
  const state = store.getState()
  const accountData = pathOr({}, ["accounts", "data"], state)
  return mkAccount(accountData)
}

const mkAccount = (account: any) => {
  const accountId = pathOr('', ['id'], account);
  const accountEmail = pathOr('', ['email'], account);
  const accountFirstName = pathOr('', ['first_name'], account);
  const accountLastName = pathOr('', ['last_name'], account);
  const accountFullName = join(" ", [accountFirstName, accountLastName])
  const accoutPhone = pathOr('', ['home_phone'], account);
  const cellMobilePhone = pathOr('', ['cellmobile_phone'], account);
  const accountRoles = pathOr([], ['roles_id'], account);
  const applicantionFilledBy = pathOr('', [META_DATA, buildLabel('application_filled_by')], account);
  const sms_alerts = pathOr('', [META_DATA, 'lendsmart_sh/sms_alerts'], account);
  const marketing_alerts = pathOr('', [META_DATA, 'lendsmart_sh/marketing_alerts'], account);
  const enableTimeout = pathOr('', [META_DATA, buildLabel('enable_login_timeout')], account);
  const enableInAppNotification = pathOr(FALSE, [META_DATA, buildLabel('enable_inapp_notification')], account);
  const shouldEnableInAppNotification = equals(SiteSettings.generalInAppNotification(), 'true') && equals(enableInAppNotification, TRUE);
  
  return {
    accountId,
    accountEmail,
    accountFirstName,
    accountLastName,
    accountFullName,
    accoutPhone,
    cellMobilePhone,
    applicantionFilledBy,
    sms_alerts,
    marketing_alerts,
    accountRoles,
    account,
    accountName: `${accountFirstName} ${accountLastName}`,
    enableTimeout,
    shouldEnableInAppNotification
  };
}

/*
useAccounts used to get values of authenticated user account's information
*/
const useAccounts = () => {
  const account = useSelector((state: ApplicationState) => {
    const { accounts } = state;
    return pathOr({}, ['data'], accounts);
  });
  return mkAccount(account)
};


export const useApplicantAccounts = () => {
  const {
    borrowerAccount
  } = useSelector((state: ApplicationState) => {
    const borrowerAccount = getActiveBorrowerAccount(state);
    const borrowerAccounts = getItemsByIdResources('applicantAccounts', state);
    const applicantAccountsLoading = state.__resources.applicantAccounts.loading;
    return {
      borrowerAccounts,
      borrowerAccount,
      isLoading: applicantAccountsLoading
    }
  });
  return mkAccount(borrowerAccount)
}

export default useAccounts;
